module.exports = __webpack_public_path__ + "static/media/title_desk.bb81faee.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/title_desk.svg
 ** module id = 481
 ** module chunks = 0
 **/